import RegisterForm from "../../components/registerForm/RegisterForm";
import { Container } from "./RegisterStyles";

const Register = () => {
  return (
    <Container>
      <RegisterForm />
    </Container>
  );
};

export default Register;
